<template>
  <div id="app">
    <a-back-top />
    <router-view/>
  </div>
</template>

<style>
html,body{
  background-color: rgb(240,242,245) !important;
}

#app{
  position: relative;
  min-width: 1280px;
  height: 100%;
  background-color: rgb(240,242,245);
}

.ant-modal-confirm-title{
  font-size: 15px !important;
  font-width: bold !important;
}

.ant-card-bordered{
  border: 1px solid #d1d1d1 !important;
}
</style>
